import { Navigate } from '@tanstack/react-router';
import { useModuleEnabled } from '../lib/enabled-modules.js';
import { GP, useGaragePath } from '../lib/paths.js';

/**
 * Ancienne adresse « Interventions » (`/g/<slug>/dossiers`) : décision du porteur du 03/10/2026, la page
 * faisait doublon avec « À l'atelier » et devient « Rendez-vous ». L'adresse est gardée (e-mails,
 * notifications, favoris) et redirige vers « Rendez-vous », ou vers l'Agenda quand le module est actif
 * (même règle que le menu : jamais les deux). Les filtres de l'ancienne page ne sont pas repris.
 */
export default function DossiersPage() {
  const gp = useGaragePath();
  const agenda = useModuleEnabled('agenda');
  return <Navigate to={gp(agenda ? GP.agenda : GP.rendezVous)} replace />;
}
